/**
 * Shared dashboard formatting helpers (2026-07-26 design audit item 5).
 * Previously copy-pasted per component — DealCycleDashboard and
 * TeamPerformanceDashboard each carried their own periodLabel/initials,
 * and money/pct lived only where first needed.
 */

export function fmtMoney(cents) {
  if (cents == null) return '$0';
  const dollars = Number(cents) / 100;
  if (dollars >= 1_000_000) return `$${(dollars / 1_000_000).toFixed(1)}M`;
  if (dollars >= 1_000) return `$${(dollars / 1_000).toFixed(0)}k`;
  return `$${Math.round(dollars).toLocaleString()}`;
}

export function pct(numerator, denominator) {
  if (!denominator) return 0;
  return Math.round((numerator / denominator) * 100);
}

export function periodLabel(p) {
  if (p === '7d') return 'last 7 days';
  if (p === '30d') return 'last 30 days';
  if (p === '90d') return 'last 90 days';
  if (p === 'all') return 'all time';
  return p;
}

export function initials(name) {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return parts[0].slice(0, 2).toUpperCase();
}
